import { render, staticRenderFns } from "./of_page.vue?vue&type=template&id=2317b38e&scoped=true&"
import script from "./of_page.vue?vue&type=script&lang=js&"
export * from "./of_page.vue?vue&type=script&lang=js&"
import style0 from "./of_page.vue?vue&type=style&index=0&id=2317b38e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2317b38e",
  null
  
)

export default component.exports